module.exports = __webpack_public_path__ + "static/media/Combos-D-FaSanKai.a38b8a37.png";